export class Signature {
  kind = "";
  signature_time = "";
  image_url = "";
}
